import cx from "classnames";
import { useState, useEffect } from "react";

import styles from "./PillBadge.module.scss";

const PillBadge = ({
  textContent,
  value,
  className = "",
  handleClick,
  selectedPillBadge = "",
}) => {
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    setIsSelected(value === selectedPillBadge);
  }, [selectedPillBadge, value]);
  return (
    <button
      onClick={handleClick}
      className={cx(
        className,
        styles.PillBadge,
        isSelected ? styles.PillBadgeSelected : null,
      )}>
      {textContent}
    </button>
  );
};

export default PillBadge;
